import { useLayoutEffect } from 'react';

export const useOrientationHook = (
  handleMediaChange: (ev?: MediaQueryListEvent | MediaQueryList, isChangeEventAdded?: boolean) => void,
  matchMediaParam = '(orientation: portrait)',
) => {
  useLayoutEffect(() => {
    const portrait = window.matchMedia(matchMediaParam);
    const handleMedia = (e: MediaQueryListEvent | MediaQueryList) => handleMediaChange(e, true);
    handleMedia(portrait);
    portrait.addEventListener('change', handleMedia);
    return portrait.removeEventListener('change', handleMediaChange);
  }, []);
};
